import { Button } from "antd";
import React, { useEffect } from "react";
import log from "cslog";
import { useItemsFine } from "../actions/app/items";
import { useTokenInit, useTokens } from "../_actions/finance";
import styles from "./styles/TokenCounter.module.css";
import TOKEN_ICON from "../media/imgs/token_test.png";

function TokenCounter({ selected_org, isMobile }) {
    const { isLoading, isSuccess, data, refetch } = useTokens(selected_org?.id);
    const mutationInitToken = useTokenInit(
        (result) => {
            // alert("Token Initialized");
            refetch();
        },
        () => {}
    );

    log.d(selected_org, "Selected Org in tcc");
    log.d(data, "Token Counter Data in tcc");

    useEffect(() => {
        if (selected_org && isSuccess && !isLoading) {
            const token_count = data?.length;
            log.d(token_count, "Token Count in tcc");
            if (token_count === 0) {
                // init token
                mutationInitToken.mutate({
                    selected_org: selected_org?.id,
                });
            }
        }
    }, [selected_org, isSuccess, isLoading, data]);

    if (isSuccess && data?.length === 0) {
        return <></>;
    }

    const token_data = data?.[0];

    return (
        <div className={styles.wrapper}>
            <div className={styles.box}>
                <img
                    src={TOKEN_ICON}
                    alt="token"
                    // style={{ height: "20px", width: "20px" }}
                    className={styles.img}
                />
                <span className={styles.count}>{token_data?.count}</span>
            </div>
        </div>
    );
}

export default TokenCounter;
